import { Badge } from 'components/atoms/Badge';
import { isNumeric } from 'utils/math';
import { prependPositiveSign } from './helpers';

type PercentageLabelProps = {
  value: number;
  comparisonLabel: string | number;
};

const PercentageLabel = ({ value, comparisonLabel }: PercentageLabelProps) => {
  if (!isNumeric(value)) return null;

  const isPositive = value > 0;

  return (
    <Badge
      color={isPositive ? 'success' : 'failure'}
      baseClassName="inline-block px-[10px] py-[3.5px] rounded-full leading-[17px]"
    >
      {`${prependPositiveSign(Math.floor(value))}% vs ${comparisonLabel} ${
        isPositive ? '💪' : ''
      }`}
    </Badge>
  );
};

export default PercentageLabel;
